<ion-grid *ngIf="!isLoading">
  <ng-container *ngIf="displayDocumentsArray && displayDocumentsArray.length > 0; else noDocs">
    <ng-container *ngFor="let group of displayDocumentsArray; let index = index">
      <ng-container *ngIf="group.showTitle">
        <ion-row class="header-row">
          <ion-col>
            <ion-title style="font-weight: 500;">{{group.title}}</ion-title>
            <ion-buttons>
              <ion-button 
              slot="primary" 
              color="transparent" 
              (click)="group.showDocs = !group.showDocs">
                <ion-icon [name]="group.showDocs ? 'chevron-down-outline' : 'chevron-back-outline'" color="primary" size="medium"></ion-icon>
              </ion-button>
            </ion-buttons>
          </ion-col>
        </ion-row>
      </ng-container>
      <ng-container *ngIf="group.showDocs">
        <ion-row *ngFor="let document of group.uploadedDocs">
          <ion-col>
            <ion-item>
              <ng-container *ngIf="document.documentType === docType.TaxDocument">
                <ion-label>{{ account.country === 'United States' ? 'W9' : 'W8'}}</ion-label>
              </ng-container>
              <!-- Birth Certificate -->
              <ion-label *ngIf="document.documentType === docType.BirthCertificate">Birth Certificate</ion-label>
              <!-- Custom Document -->
              <ion-label *ngIf="document.documentType === undefined || document.documentType === null">
                {{ document.organizationRequiredDocument.name }} ({{group.org?.name}})
              </ion-label>
              <ion-buttons>
                <ion-button fill="solid" color="primary" (click)="showDoc(document)">View</ion-button>
                <ion-button fill="solid" color="danger" (click)="removeDoc(document)">Remove</ion-button>
              </ion-buttons>
            </ion-item>
          </ion-col>
        </ion-row>
        <ion-row *ngFor="let document of group.missingDocs">
          <ion-col>
            <ion-item>
              <ng-container *ngIf="document.documentType === docType.TaxDocument">
                <ion-label>{{ account.country === 'United States' ? 'W9' : 'W8'}}</ion-label>
              </ng-container>
              <!-- Birth Certificate -->
              <ion-label *ngIf="document.documentType === docType.BirthCertificate">Birth Certificate</ion-label>
              <!-- Custom Document -->
              <ion-label *ngIf="document.documentType === undefined || document.documentType === null">
                {{ document.organizationRequiredDocument.name }} ({{group.org?.name}})
              </ion-label>
              <ion-buttons>
                <ng-container *ngIf="document.organizationRequiredDocument">
                  <ng-container *ngIf="document.organizationRequiredDocument.name.includes('Tax'); else docPreview">
                    <ion-button (click)="account.country === 'United States' ? showIrsTaxDoc('W9') : showIrsTaxDoc('W8')">View</ion-button>
                  </ng-container>
                  <ng-template #docPreview>
                    <ion-button *ngIf="document.organizationRequiredDocument.url" (click)="showDocPreview(document.organizationRequiredDocument)">View</ion-button>
                  </ng-template>
                </ng-container>
                <ion-button fill="solid" color="warning" (click)="showDoc(document)">Upload Now</ion-button>
              </ion-buttons>
            </ion-item>
          </ion-col>
        </ion-row>
      </ng-container>
    </ng-container>
  </ng-container>
  <ng-template #noDocs>
    <ion-row>
      <ion-col>
        <ion-title color="danger">No documents to display</ion-title>
      </ion-col>
    </ion-row>
  </ng-template>
</ion-grid>
  
